import React from 'react';
import { Container, Typography, Grid, Box } from '@mui/material';
import { motion } from 'framer-motion';
import './TechStack.css';

const technologies = {
  frontend: [
    { name: 'React', icon: '/assets/tech-logos/react.png' },
    { name: 'Angular', icon: '/assets/tech-logos/angular.png' },
    // { name: 'Vue.js', icon: '/assets/tech-logos/vue.png' },
    { name: 'Next.js', icon: '/assets/tech-logos/nextjs.png' },
    { name: 'TypeScript', icon: '/assets/tech-logos/typescript.png' },
    { name: 'JavaScript', icon: '/assets/tech-logos/javascript.png' },
    { name: 'Tailwind CSS', icon: '/assets/tech-logos/tailwind.png' }
  ],
  backend: [
    { name: 'Node.js', icon: '/assets/tech-logos/nodejs.png' },
    { name: 'Python', icon: '/assets/tech-logos/python.png' },
    // { name: 'Java', icon: '/assets/tech-logos/java.png' },
    // { name: 'C#', icon: '/assets/tech-logos/csharp.png' },
    { name: 'PHP', icon: '/assets/tech-logos/php.png' },
    // { name: 'Go', icon: '/assets/tech-logos/golang.png' }
  ],
  database: [
    { name: 'MongoDB', icon: '/assets/tech-logos/mongodb.png' },
    // { name: 'PostgreSQL', icon: '/assets/tech-logos/postgresql.png' },
    { name: 'MySQL', icon: '/assets/tech-logos/mysql.png' },
    // { name: 'Redis', icon: '/assets/tech-logos/redis.png' },
    { name: 'Firebase', icon: '/assets/tech-logos/firebase.png' },
    { name: 'GraphQL', icon: '/assets/tech-logos/graphql.png' }
  ],
  cloud: [
    { name: 'Docker', icon: '/assets/tech-logos/docker.png' },
    { name: 'Kubernetes', icon: '/assets/tech-logos/kubernetes.png' },
    { name: 'AWS', icon: '/assets/tech-logos/aws.png' },
    { name: 'Google Cloud', icon: '/assets/tech-logos/gcp.png' },
    { name: 'Jenkins', icon: '/assets/tech-logos/jenkins.png' },
    // { name: 'Azure', icon: '/assets/tech-logos/azure.png' }
  ]
};

const categories = [
  { id: 'frontend', title: 'Frontend Development', subtitle: 'Modern and responsive user interfaces' },
  { id: 'backend', title: 'Backend Development', subtitle: 'Scalable and secure server solutions' },
  { id: 'database', title: 'Database Technologies', subtitle: 'Reliable data storage and management' },
  { id: 'cloud', title: 'Cloud & DevOps', subtitle: 'Robust deployment and scaling' }
];

const TechStack = () => {
  return (
    <section className="tech-stack">
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="tech-header"
        >
          <Typography variant="h2" className="section-title" gutterBottom>
            Our Technology Stack
          </Typography>
          <Typography variant="subtitle1" className="sd-ts-section-subtitle" gutterBottom>
            Cutting-edge technologies for modern software solutions
          </Typography>
        </motion.div>

        <Grid container spacing={3}>
          {/* Frontend and Backend sections */}
          {categories.slice(0, 2).map((category, categoryIndex) => (
            <Grid item xs={12} key={category.id}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: categoryIndex * 0.1 }}
              >
                <Box className="category-container">
                  <Typography variant="h5" className="ts-category-title">
                    {category.title}
                  </Typography>
                  <Typography variant="subtitle2" className="category-subtitle">
                    {category.subtitle}
                  </Typography>
                  <Grid container spacing={2} className="tech-grid">
                    {technologies[category.id].map((tech, techIndex) => (
                      <Grid item xs={6} sm={4} md={2} key={tech.name}>
                        <motion.div
                          className="tech-item"
                          whileHover={{ y: -5 }}
                          initial={{ opacity: 0, y: 20 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true }}
                          transition={{ duration: 0.3, delay: techIndex * 0.05 }}
                        >
                          <img
                            src={tech.icon}
                            alt={tech.name}
                            className="tech-icon"
                          />
                          <Typography variant="body2" className="tech-name">
                            {tech.name}
                          </Typography>
                        </motion.div>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </motion.div>
            </Grid>
          ))}

          {/* Database and Cloud sections side by side */}
          <Grid item xs={12}>
            <Grid container spacing={3}>
              {categories.slice(2).map((category, categoryIndex) => (
                <Grid item xs={12} md={6} key={category.id}>
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: (categoryIndex + 2) * 0.1 }}
                  >
                    <Box className="category-container" style={{ height: '100%' }}>
                      <Typography variant="h5" className="ts-category-title">
                        {category.title}
                      </Typography>
                      <Typography variant="subtitle2" className="category-subtitle">
                        {category.subtitle}
                      </Typography>
                      <Grid container spacing={2} className="tech-grid">
                        {technologies[category.id].map((tech, techIndex) => (
                          <Grid item xs={6} sm={4} key={tech.name}>
                            <motion.div
                              className="tech-item"
                              whileHover={{ y: -5 }}
                              initial={{ opacity: 0, y: 20 }}
                              whileInView={{ opacity: 1, y: 0 }}
                              viewport={{ once: true }}
                              transition={{ duration: 0.3, delay: techIndex * 0.05 }}
                            >
                              <img
                                src={tech.icon}
                                alt={tech.name}
                                className="tech-icon"
                              />
                              <Typography variant="body2" className="tech-name">
                                {tech.name}
                              </Typography>
                            </motion.div>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
};

export default TechStack; 